import ExportWorkflow from '../../../../../components/workflows/general/export-workflow';

angular
    .module('festzelt-os.modules.bo.option-links')
    .factory('exportOptionLinks', [
        'Alert',
        '$http',
        '$uibModal',
        '$translate',
        (Alert, $http, $uibModal, $translate) => new ExportWorkflow('option-links', Alert, $http, $uibModal, $translate)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/bo/option-links/workflows/option-links-list/export-option-links.js